import {
  type SimpleShowResPagedData,
  type SiteShowSummaryResPagedData,
} from '@on3/api';
import { BreadCrumb } from 'components/BreadCrumb/BreadCrumb';
import type { IShowsIndexProps } from 'pages/shows';

import { CollegeShowsItem } from './ShowItems/CollegeShowsItem';
import { ShowsItem } from './ShowItems/ShowsItem';
import styles from './ShowsIndex.module.scss';

interface ShowsIndexProps {
  nationalList?: SimpleShowResPagedData;
  collegeList?: SiteShowSummaryResPagedData;
  title?: string;
}

export const ShowsIndex = ({
  collegeList,
  nationalList,
  title,
}: ShowsIndexProps) => {
  return (
    <>
      <BreadCrumb
        crumbs={[{ title: 'On3', href: '/' }]}
        title="Podcast and Shows"
      />
      <div className={styles.block}>
        <h1>{title}</h1>
        <section>
          <h2>On3 National</h2>
          <ul>
            {nationalList?.list?.map((item) => (
              <ShowsItem item={item} key={item.key} />
            ))}
          </ul>
        </section>
        <section>
          <h2>College Teams</h2>
          <ul>
            {collegeList?.list?.map((item) => (
              <CollegeShowsItem item={item} key={item?.organization?.key} />
            ))}
          </ul>
        </section>
      </div>
    </>
  );
};
